import {AxiosError} from 'axios';
import {POST_SINGPASS_CALLBACK_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Response Model
// =============================================================================
interface PostSingPassTokenRequest {
  code: string | null;
  state: string | null;
}

interface PostSingPassTokenResponse {
  userExist: boolean;
  myInfoRedirectUrl: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess: (data: PostSingPassTokenResponse) => void;
  onError: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSingPassToken = ({onSuccess, onError}: Input) => {
  const postSingPassToken = async (data: PostSingPassTokenRequest) => {
    const res = await axiosClient.post<PostSingPassTokenResponse>(POST_SINGPASS_CALLBACK_URL, data);

    return res.data;
  };

  return useCustomMutation(
      postSingPassToken,
      {
        onSuccess,
        onError,
      },
      false
  );
};
